import React from "react";
import { ExternalLink } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { MARKETPLACE, PLATFORM_LOGOS } from "@/data/treasures";
import { Eyebrow, SectionTitle } from "@/components/shared";
import { Ornament } from "@/components/Ornament";

const PLATFORMS = [
  { key: "tutti", url: MARKETPLACE.tutti, logo: PLATFORM_LOGOS.tutti },
  { key: "ricardo", url: MARKETPLACE.ricardo, logo: PLATFORM_LOGOS.ricardo },
  { key: "anibis", url: MARKETPLACE.anibis, logo: PLATFORM_LOGOS.anibis },
];

export const MarketplaceModule = () => {
  const { t } = useLang();
  return (
    <section data-testid="marketplace-module" className="relative py-24 md:py-32 bg-espresso grain-overlay overflow-hidden">
      <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(circle at 80% 20%, rgba(200,169,126,0.14), transparent 55%)" }} />
      <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
        <Eyebrow dark>{t.market.eyebrow}</Eyebrow>
        <SectionTitle dark>{t.market.title}</SectionTitle>
        <p className="mt-5 max-w-2xl mx-auto text-cream/70 font-sans leading-relaxed">{t.platforms.same}</p>
        <Ornament className="my-9 opacity-70" width={220} />
        <div className="grid sm:grid-cols-3 gap-5 max-w-3xl mx-auto">
          {PLATFORMS.map((p) => (
            <a key={p.key} href={p.url} target="_blank" rel="noreferrer" data-testid={`marketplace-${p.key}`}
              className="group flex flex-col items-center gap-4 rounded-2xl border border-gold/30 bg-gold/[0.04] px-6 py-8 transition-all duration-400 hover:border-gold hover:bg-gold/[0.08] hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(200,169,126,0.2)]">
              <div className="h-14 w-full flex items-center justify-center">
                <img src={p.logo} alt={t.platforms[p.key]} className="max-h-12 max-w-[140px] object-contain" />
              </div>
              <span className="inline-flex items-center gap-2 text-sm text-cream/80 group-hover:text-gold transition-colors text-center">
                {t.platforms[p.key]} <ExternalLink className="w-4 h-4 shrink-0" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export const MarketplaceButtons = () => {
  const { t } = useLang();
  return (
    <div className="flex flex-wrap gap-3" data-testid="marketplace-buttons">
      {PLATFORMS.map((p) => (
        <a key={p.key} href={p.url} target="_blank" rel="noreferrer" data-testid={`footer-${p.key}`} title={t.platforms[p.key]}
          className="inline-flex items-center justify-center h-11 w-16 rounded-lg bg-cream/95 hover:bg-cream transition-colors ring-1 ring-gold/20">
          <img src={p.logo} alt={t.platforms[p.key]} className="max-h-7 max-w-[52px] object-contain" />
        </a>
      ))}
    </div>
  );
};

export default MarketplaceModule;
